import { Disclosure } from '@headlessui/react';

const PolicyCard: React.FC = ({ children }) => (
  <Disclosure as="div">{children}</Disclosure>
);

export default PolicyCard;
